import router from '../../../router'
import moment from 'moment'

export const documents = {
    state: {
        status: 'idle',
        documents: null,
        sortOptions: [
            {
                query: 'name',
                label: 'Nazwa dokumentu'
            },
            {
                query: 'date',
                label: 'Data'
            },
            {
                query: 'activeFrom',
                label: 'Data obwiązywania od'
            },
            {
                query: 'serviceName',
                label: 'Usługa'
            }
        ],
        sort: {
            by: 'name',
            direction: 'desc'
        },
        pagination: {
            page: 1,
            totalPages: 0,
            perPage: 10,
            totalRecords: null
        },
        filters: {
            active: {
                type: 'ui-checkbox-input',
                value: true,
                text: 'Aktywne'
            },
            partOfName: {
                type: 'search-input',
                value: '',
                searchParamsTooltip: ['nazwie usługi', 'nazwie dokumentu']
            },
            dateFrom: {
                type: 'range-date',
                range: 'from',
                text: 'Od',
                title: 'Data dodania dokumentu',
                additionalText: 'Data od',
                value: '',
                groupName: 'range'
            },
            dateTo: {
                type: 'range-date',
                range: 'to',
                text: 'Do',
                additionalText: 'Data do',
                value: '',
                groupName: 'range'
            }
        }
    },
    mutations: {
        RESET_DOCUMENTS_FILTERS(state, payload) {
            state.filters = payload
        },
        SET_DOCUMENTS_FILTER(state, payload) {
            state.filters[payload.filter].value = payload.value
        },
        SET_DOCUMENTS_PER_PAGE(state, payload) {
            state.pagination.perPage = payload
        },
        SET_DOCUMENTS_CURRENT_PAGE(state, payload) {
            state.pagination.page = payload
        },
        SET_DOCUMENTS_TOTALRECORDS(state, payload) {
            state.pagination.totalRecords = payload
        },
        SET_DOCUMENTS_TOTALPAGES(state, payload) {
            state.pagination.totalPages = payload
        },
        SET_DOCUMENTS_STATUS(state, payload) {
            state.status = payload
        },
        SET_DOCUMENTS(state, payload) {
            state.documents = payload
        },
        SET_DOCUMENTS_SORT(state, payload) {
            state.sort = payload
        }
    },
    actions: {
        setDocumentsPerPage({ commit }, payload) {
            commit('SET_DOCUMENTS_PER_PAGE', payload)
        },
        documentsFetch({ state, commit, getters }) {
            commit('SET_DOCUMENTS_STATUS', 'loading')

            if (router.currentRoute.query.page) {
                commit(
                    'SET_DOCUMENTS_CURRENT_PAGE',
                    +router.currentRoute.query.page
                )
            }

            const filters = {}
            Object.keys(state.filters).map((filter, idx) => {
                if (state.filters[filter].value) {
                    const value = state.filters[filter].value
                    if (filter === 'active') {
                        filters.archived = false
                    }

                    if ((filter === 'dateFrom' || filter === 'dateTo') && moment(value).isValid()) {
                        const time = filter === 'dateFrom' ? '00:00' : '23:59'
                        filters[filter] = moment(value).format(
                            `DD-MM-YYYY ${time}`
                        )
                    } else if (filter === 'partOfName') {
                        filters.serviceName = value
                        filters.partOfName = value
                    }else {
                        filters[filter] = value
                    }
                }
            })

            return this.$api
                .post(
                    'users_documents',
                    {
                        userId: getters.userId,
                        orderDirection: state.sort.direction.toUpperCase(),
                        orderBy: state.sort.by,
                        isOr: true
                    },
                    {
                        params: {
                            page: state.pagination.page - 1,
                            count: state.pagination.perPage,
                            ...filters
                        }
                    }
                )
                .then(response => {
                    commit(
                        'SET_DOCUMENTS_TOTALRECORDS',
                        response.data.data.total
                    )
                    commit(
                        'SET_DOCUMENTS_TOTALPAGES',
                        Math.ceil(
                            response.data.data.total / state.pagination.perPage
                        )
                    )
                    commit('SET_DOCUMENTS', response.data.data.documentList)
                })
                .catch(error => {
                    console.log(error)
                })
                .finally(() => {
                    commit('SET_DOCUMENTS_STATUS', 'idle')
                })
        },
        setDocumentsSort({ commit }, payload) {
            commit('SET_DOCUMENTS_SORT', payload)
        }
    },
    getters: {
        getDocumentsFilters: state => state.filters,
        getDocumentsStatus: state => state.status,
        getDocumentsSortOptions: state => state.sortOptions,
        getDocumentsSort: state => state.sort,
        getDocumentsPaging: state => state.pagination,
        getDocuments: state => {
            if (state.documents) {
                return state.documents
            }
        }
    }
}
